import React, { useState, Fragment, useEffect } from "react";
export default function Masking({ input, inputType, number }) {
    const [text, setText] = useState(input);
    useEffect(() => {
        if (text !== "" && text !== undefined && text !== null) {
            if (number === undefined || number === null || number === '') {
                number = 1;
            }
            if (inputType === "mobile") {
                let maskedValue = "";
                for (let i = 0; i < text.length - number; i++) {
                    maskedValue += "X";
                }
                setText(maskedValue + text.substring(text.length - number, text.length));
            }
            else if (inputType === "email") {
                let maskedvalue = text.replace(/()(.*)(?=@)/,
                    function (gp1, gp2, gp3) {
                        for (let i = 0; i < gp3.length; i++) {
                            gp2 += "X";
                        } return gp2;
                    });
                setText(maskedvalue)
            }
        }
    }, [input]);

    return <Fragment>{text}</Fragment>;
}